// Autogenerated file
export const tariffTypesEnum = {
    ExploitationForOneMonth: "ExploitationForOneMonth",
    RefuelingForOneMonth: "RefuelingForOneMonth",
    Logistic50ForOneMonth: "Logistic50ForOneMonth",
    Logistic100ForOneMonth: "Logistic100ForOneMonth",
    Logistic101ForOneMonth: "Logistic101ForOneMonth",
    ExploitationForThreeMonths: "ExploitationForThreeMonths",
    RefuelingForThreeMonths: "RefuelingForThreeMonths",
    Logistic50ForThreeMonths: "Logistic50ForThreeMonths",
    Logistic100ForThreeMonths: "Logistic100ForThreeMonths",
    Logistic101ForThreeMonths: "Logistic101ForThreeMonths",
    CrStart10: "CrStart10",
    LogisticLiteWithRefueling: "LogisticLiteWithRefueling",
    CrStart5: "CrStart5",
};
export const tariffTypes = [
    { label: "Модуль Эксплуатация на 1 месяц", value: "ExploitationForOneMonth" },
    { label: "Модуль Топливное планирование на 1 месяц", value: "RefuelingForOneMonth" },
    { label: "Модуль Логистика для компаний с парком до 50 ед. техники на 1 месяц", value: "Logistic50ForOneMonth" },
    { label: "Модуль Логистика для компаний с парком от 51 до 100 ед. техники на 1 месяц", value: "Logistic100ForOneMonth" },
    { label: "Модуль Логистика для компаний с парком более 100 ед. техники на 1 месяц", value: "Logistic101ForOneMonth" },
    { label: "Модуль Эксплуатация на 3 месяца", value: "ExploitationForThreeMonths" },
    { label: "Модуль Топливное планирование на 3 месяца", value: "RefuelingForThreeMonths" },
    { label: "Модуль Логистика для компаний с парком до 50 ед. техники на 3 месяца", value: "Logistic50ForThreeMonths" },
    { label: "Модуль Логистика для компаний с парком от 51 до 100 ед. техники на 3 месяца", value: "Logistic100ForThreeMonths" },
    { label: "Модуль Логистика для компаний с парком более 100 ед. техники на 3 месяца", value: "Logistic101ForThreeMonths" },
    { label: "Модуль CrStart до 10 ТС", value: "CrStart10" },
    { label: "Модуль Логистика Лайт с топливным планированием", value: "LogisticLiteWithRefueling" },
    { label: "Модуль CrStart до 5 ТС", value: "CrStart5" },
];
